module.exports = __webpack_public_path__ + "8af4c196d80d7f8d2d7c37e3b8fe3a6a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/advisory/zalo.png
// module id = ./assets/images/advisory/zalo.png
// module chunks = 0